// import HomePage from "./pages/Home/index.jsx";
// import PageLoader from "./components/loader.jsx";
// import { Toaster } from 'react-hot-toast';

// function App() {
//   return (
//     <>
//       <Toaster position="top-right" reverseOrder={true} />
//       <PageLoader />
//       <HomePage />
//     </>
//   );
// }

// export default App;



import { useEffect } from "react";
import HomePage from "./pages/Home/index.jsx";
import PageLoader from "./components/loader.jsx";
import { Toaster } from "react-hot-toast";
import SmoothScroll from "./components/smoothscroll.jsx";
// import N8nChat from "./components/n8nchat/N8nChat.jsx";
// import CrispChat from "./components/crisp.jsx";

function App() {

  useEffect(() => {
    // Google Analytics script load karna
    const script = document.createElement("script");
    script.src = "https://www.googletagmanager.com/gtag/js?id=G-77ZK22L9WD";
    script.async = true;
    document.head.appendChild(script);

    // gtag initialize karna
    window.dataLayer = window.dataLayer || [];
    function gtag() { window.dataLayer.push(arguments); }
    gtag("js", new Date());
    gtag("config", "G-77ZK22L9WD");
  }, []);

  // useEffect(() => {
  //   new CrispChat();
  // }, []);


  return (
    <>
      <Toaster position="top-right" reverseOrder={true} />
      <PageLoader />
      <SmoothScroll />
      <HomePage />
      {/* <N8nChat/> */}

      {/* <CrispChat /> */}

    </>
  );
}

export default App;
